import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=48615e20&scoped=true"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"
import style0 from "./Demand.vue?vue&type=style&index=0&id=48615e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48615e20",
  null
  
)

export default component.exports